<template>
    <div class="modal fade apartment_details_modal" id="itemDetailsModal" tabindex="-1" role="dialog"
         aria-hidden="true" data-keyboard="false">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="dismiss-modal-btn" data-dismiss="modal" aria-label="Close">
                <i class="fad fa-times-circle"></i>
            </div>
            <div class="modal-content" v-if="item">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12 mgb-3">
                            <div class="modal-heading" v-switch="item.type">
                                <h1 v-case="'apartment'"> Apartament nr. {{ item.apartment_number }}, {{ item.level ? item.level.name : '' }} </h1>
                                <h1 v-case="'house'"> Casa nr. {{ item.apartment_number }} </h1>
                                <h1 v-case="'commercial'"> Spaţiu nr. {{ item.apartment_number }}, {{ item.level ? item.level.name : '' }} </h1>
                            </div>
                        </div>
                    </div>
                    <div class="row b-bottom">
<!--                        <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 mb-4">-->
<!--                            <h2 class="modal-col-heading"> Client: </h2>-->
<!--                            -->
<!--                            <div class="v-select-container" v-if="selectedClient">-->
<!--                                <span style="color: #6771e2;">-->
<!--                                  <strong v-if="selectedClient.user_id"><a :href="'/messages/' + item.project_id + '/' + selectedClient.id">{{selectedClient.first_name+' '+selectedClient.last_name}}</a></strong>-->
<!--                                  <strong v-else>{{selectedClient.first_name+' '+selectedClient.last_name}}</strong>-->
<!--                                </span>-->
<!--                               -->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12 mb-4" v-if="canManage">
                            <h2 class="modal-col-heading"> Status: {{(item.status === 'reserved') ? 'Rezervat' : ((item.status === 'available') ? 'Disponibil' : 'Vandut')}}</h2>
                        </div>
                    </div>
                    <div class="row b-bottom">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12 mt-2">
                            <h2 class="modal-col-heading"> Notite </h2>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="messages-container" v-if="item.notes">
                                <div class="single-message message-received"
                                     :class="note.u_id === authId ? 'message-sent' : 'message-received'"
                                     v-for="(note, index) in item.notes" :key="index">
                                    <div class="single-message-heading">
                                        <h3 v-if="note.u_id !== authId"> {{ note.name }} </h3>
                                        <span> {{ note.date }} </span>
                                    </div>
                                    <div class="single-message-content">
                                        <p>
                                            {{ note.txt }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="create-message-container mgb-3">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <textarea name="description" id="new_message" v-model="noteTxt"></textarea>
                                        <div class="input-icon">
                                            <i class="fad fa-comment-alt-lines"></i>
                                        </div>
                                        <label class="custom-label" for="new_message"> * Mesaj nou </label>
                                    </div>
                                    <p class="custom-input-error"></p>
                                </div>
                                <div class="center-content mt-3">
                                    <button type="button" name="button" class="general-btn positive-btn"
                                            @click="saveNote()">
                                        <i class="fad fa-paper-plane"></i>
                                        <span> Salveaza notite </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="mt-3 d-flex justify-content-end">
                                <button type="button" name="button" class="general-btn negative-btn"
                                        data-dismiss="modal"><i class="fad fa-times-circle"></i>
                                    <span> Inchide </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  //import vSelect from 'vue-select'

  export default {
    name: "DeveloperItemDetailsModal",
    // components: {
    //   vSelect,
    // },
    props: ['projectId', 'modelId',],
    data() {
      return {
        authId: this.$userId,
        item: null,
        noteTxt: null,
        project:null,
        model:null,
        clients: [],
        selectedClient: null,
        canManage: false
      }
    },
    async mounted() {
      let vm = this
      $('#itemDetailsModal').on('hidden.bs.modal', function () {
        vm.item = null
        vm.selectedClient = ''
        vm.noteTxt = null
        vm.canManage = false
      });
      this.$eventBus.$on('OPEN_ITEM_DETAIL_MODAL',async function (payLoad) {
        vm.triggerLoader(true)
        await vm.getItemData(payLoad.itemId)
        vm.canManage = payLoad.canManage;
        // await vm.getClientsList()
        // vm.selectedClient = vm.clients.find(client => client.id === vm.item.client_id)
        vm.triggerLoader(false)
        $('#itemDetailsModal').modal('show')
      });
    },
    methods: {
      async getClientsList() {
        let vm = this
        await window.axios.get(`/developer/clients/data-list/${this.item.project_id}`)
          .then(function (resp) {
            vm.clients = resp.data.data
          })
          .catch(function (err) {
            window.showError(err)
          });
      },
      saveNote() {
        let vm = this
        if (this.noteTxt !== '' && this.noteTxt !== null) {
          this.triggerLoader(true)
          window.axios.post(`/developer/items/add-note`,
            {
              note_txt: this.noteTxt,
              item_id: this.item.id
            }
          )
            .then(function (response) {
              vm.triggerLoader(false)
              vm.item.notes = response.data.data.notes
              vm.noteTxt = null
            })
            .catch(function (err) {
              vm.triggerLoader(false)
              window.showError(err)
            });
        }
      },
    async getItemData(itemId) {
        let vm = this
        await window.axios.get(`/developer/items/${itemId}`)
          .then(function (resp) {
            vm.item = resp.data.data
          })
          .catch(function (err) {
            window.showError(err)
          });
      }
    }
  }
</script>
